
import React, { useState } from 'react';
import './Projects.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faEye, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faApple, faSwift, faReact, faPython, faNode, faJsSquare, faGoogle, faGolang, faCss3 } from '@fortawesome/free-brands-svg-icons';
import { faRobot, faServer, faDatabase, faFileCode, faCogs } from '@fortawesome/free-solid-svg-icons';
import { faDocker } from '@fortawesome/free-brands-svg-icons';

// Map technology names to FontAwesome icons
const iconMapping = {
  "Swift": faSwift,
  "iOS Development": faApple,
  "React.js": faReact,
  "Flask": faPython,
  "Transformers": faRobot,
  "PyTorch": faPython,
  "TypeScript": faFileCode,
  "Gemini API": faGoogle,
  "Python": faPython,
  "Kubernetes": faCogs,
  "Firebase": faDatabase,
  "Go": faGolang,
  "Docker": faDocker,
  "Tailwind CSS": faCss3,
  "PostgreSQL": faDatabase
  // Add other technology mappings here if needed
};

const projectsData = [
  {
    id: 'piepal',
    title: "Pie Pal",
    description: "Multimodal assistant to aid visually impaired individuals order food online",
    image: process.env.PUBLIC_URL + "/PiePalIcon.png",
    technologies: ["React.js", "Flask", "Transformers", "PyTorch"],
    githubUrl: "https://atri-lab.github.io/PiePal/",
    viewUrl: "https://drive.google.com/file/d/119IiOYMUoi9E-03T1JWm9utLLtJO1crO/view"
  },
  {
    id: 'cardioscope',
    title: "CardioScope",
    description: "Analyzes patient data to detect cardiovascular risk clusters and visualizes key clinical health indicators",
    image: process.env.PUBLIC_URL + "/CardioScopeIcon.png",
    technologies: ["TypeScript", "React.js", "Tailwind CSS", "Go", "Python", "PostgreSQL", "Docker"],
    githubUrl: "https://github.com/Atri-lab/CardioScope",
    viewUrl: "https://drive.google.com/file/d/1f7OhesTt6G077KD09qnuY-3TLSIdCcoE/view?usp=sharing"
  },
  {
    id: 'wolfieeats',
    title: "Wolfie Eats",
    description: "Revolutionized campus dining with real-time updates for 30K+ students",
    image: process.env.PUBLIC_URL + "/WolfieEatsIcon.png",
    technologies: ["Swift", "Firebase"],
    githubUrl: "https://github.com/Atri-lab/WolfieEats",
    viewUrl: "https://drive.google.com/file/d/1A_rb1I1oK3Z4Q4s2v7uc2RDHrreZBpYH/view?usp=drive_link"
  },
  {
    id: 'investofolio',
    title: "Investofolio",
    description: "Dashboard with real-time portfolio analysis to promote financial literacy",
    image: process.env.PUBLIC_URL + "/InvestofolioIcon.png",
    technologies: ["TypeScript", "React.js", "Gemini API", "Python", "Kubernetes"],
    githubUrl: "https://github.com/Atri-lab/Investofolio",
    viewUrl: "https://atri-lab.github.io/Investofolio/"
  }
];

const Projects = () => {
  const [activeId, setActiveId] = useState(null);

  return (
    <section className="projects" id="projects">
      <div className="projects-container">
        {projectsData.map((project) => (
          <div
            key={project.id}
            className={`project-panel ${activeId === project.id ? 'active' : ''}`}
            onMouseEnter={() => setActiveId(project.id)}
            onMouseLeave={() => setActiveId(null)}
            // For touch devices, click triggers active
            onClick={() => setActiveId(activeId === project.id ? null : project.id)}
          >
            <div className="panel-bg" style={{ backgroundImage: `url(${project.image})` }}></div>
            <div className="panel-overlay"></div>

            <div className="panel-content">
              <h3 className="project-title">{project.title}</h3>

              <div className="project-details">
                <p className="project-desc">{project.description}</p>
                <div className="project-tags">
                  {project.technologies.map((tech, idx) => (
                    <span key={idx} className="tag">
                      {iconMapping[tech] && <FontAwesomeIcon icon={iconMapping[tech]} />} {tech}
                    </span>
                  ))}
                </div>
                <div className="project-links">
                  <a href={project.viewUrl} target="_blank" rel="noopener noreferrer" className="link-btn" onClick={(e) => e.stopPropagation()}>
                    <FontAwesomeIcon icon={faEye} /> View
                  </a>
                  <a href={project.githubUrl} target="_blank" rel="noopener noreferrer" className="link-btn" onClick={(e) => e.stopPropagation()}>
                    <FontAwesomeIcon icon={faGithub} /> Code
                  </a>
                </div>
              </div>

              {!activeId && (
                <div className="expand-hint">
                  <FontAwesomeIcon icon={faArrowRight} />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
